import { IPublicClientApplication } from '@azure/msal-browser';
import axios from 'axios';
import { getSilentRequest } from '../app/authentication/get-silent-request';
import { sanitizeObjectKeys, validateAndSanitizeUrl } from '../utils/input-validation';

export async function post<T>(url: string, instance: IPublicClientApplication, body: object): Promise<T> {
    // Validate and sanitize the URL
    const { isValid: urlValid, url: sanitizedUrl } = validateAndSanitizeUrl(url);
    if (!urlValid) {
        throw new Error('Invalid URL provided');
    }

    // Sanitize request body to prevent injection attacks
    const sanitizedBody = sanitizeObjectKeys(body);

    const tokenResponse = await instance.acquireTokenSilent(getSilentRequest());

    const config = {
        headers: {
            Authorization: `Bearer ${tokenResponse.accessToken}`
        }
    };

    const response = await axios.post(sanitizedUrl, sanitizedBody, config);
    return response.data;
}
